import { maybeCastValueFromString } from './cast'
import { iterateNested } from './json'

/**
 * Converts a json object to FormData
 * 
 * @param {Object}                    json 
 * @param {URLSearchParams|undefined} searchParameters
 * @param {Boolean}                   asObject         Whether we should return the searchParam object instead of a string
 * 
 * @returns {URLSearchParams|String}
 */
export const toQueryString = (json, searchParameters, asObject = false) => {
    searchParameters = searchParameters instanceof URLSearchParams
        ? searchParameters
        : new URLSearchParams()

    iterateNested(
        json,
        (key, value) => {
            if (
                value === undefined 
                || value === null 
                || value === '' 
                || (Array.isArray(value) && value.length === 0)
                || (value instanceof Object && Object.keys(value).length === 0)
            ) {
                searchParameters.delete(key)
            } else {
                searchParameters.set(key, maybeCastValueFromString(value))
            }
        },
        true
    )

    return asObject
        ? searchParameters
        : decodeURIComponent(searchParameters.toString())
}